import axios from "axios";

// The few fields the signup page needs to offer "Continue as …" to a patient
// who is already logged in, and to refill the visit funnel's cookies for them.
// It reads the same patientRecord the portal loads on every visit to /me, through
// the portal's GraphQL endpoint, which authenticates with the session cookie.
const LOGGED_IN_PATIENT_QUERY = `query SignupLoggedInPatient {
  patientRecord {
    patient {
      id
      firstName
      email
      phone
      gender
      usState
    }
  }
}`;

// fetchLoggedInPatient returns the logged-in patient, or null when the session
// doesn't resolve to one. Network and auth errors reject; callers treat any
// failure as "not logged in".
export async function fetchLoggedInPatient() {
  const response = await axios.post(
    "/me/gql/graphql",
    { query: LOGGED_IN_PATIENT_QUERY },
    { withCredentials: true },
  );
  const patient = response?.data?.data?.patientRecord?.patient;
  return patient && patient.id ? patient : null;
}
